import { styled } from '@spazious/dollhouse-theme';

import { Flex, FlexElement, FlexProps } from '../Flex/index.js';

export type TooltipContentElement = FlexElement;

export interface TooltipContentProps extends FlexProps {}

export const TooltipContent = styled(Flex).withConfig({
  displayName: 'TooltipContent',
})`
  border-radius: var(--shape-rounded-radius);
  overflow: hidden;
`;

export default TooltipContent;
